import { useEffect } from "react";
import { ArrowLeft, X } from "lucide-react";

/**
 * Jendela: di tengah layar pada desktop, layar penuh pada HP dengan tombol
 * kembali ke panel akun. Dipakai jendela Profil & buku alamat.
 */
export default function SheetDialog({ title, onClose, onBack, children, tid, lebar = "max-w-lg" }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[70] flex items-stretch justify-center bg-black/40 sm:items-center sm:p-4"
      data-testid={`${tid}-overlay`} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} data-testid={tid}
        className={`flex w-full flex-col bg-white sm:${lebar} sm:max-h-[86vh] sm:rounded-[8px] sm:shadow-2xl`}>
        <div className="flex items-center gap-2 border-b border-[#E5E5EA] px-4 py-3">
          <button type="button" onClick={onBack || onClose} aria-label="Kembali" data-testid={`${tid}-back`}
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[#1D1D1F] hover:bg-[#F5F5F7] sm:hidden">
            <ArrowLeft size={18} strokeWidth={1.8} />
          </button>
          {onBack && (
            <button type="button" onClick={onBack} aria-label="Kembali" data-testid={`${tid}-back-d`}
              className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-full text-[#1D1D1F] hover:bg-[#F5F5F7] sm:inline-flex">
              <ArrowLeft size={18} strokeWidth={1.8} />
            </button>
          )}
          <h2 className="flex-1 truncate font-heading text-base font-bold text-[#1D1D1F] md:text-lg">{title}</h2>
          <button type="button" onClick={onClose} aria-label="Tutup" data-testid={`${tid}-close`}
            className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-full text-[#1D1D1F] hover:bg-[#F5F5F7] sm:inline-flex">
            <X size={18} strokeWidth={1.8} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-4 py-4">{children}</div>
      </div>
    </div>
  );
}
